import { Suspense, lazy } from "react";
import Loader from "../customs/loader/main";
import Layout from "../components/dashboard/main";

const Main = lazy(() => import("../components/nomination/main"));

const Nomination = () => {
  return (
    // <Layout pageHeading="Nomination">
      <Suspense fallback={<Loader />}>
        <Main />
      </Suspense>
    // </Layout>
  );
};

export default Nomination;
